import axios from "axios";
import {FOOTER_API_URL, REDES_SOCIALES_API_URL} from "./URL";

export const getFooter = async () => {
    const params = {};
    params[`populate`] = '*'
    return axios.get(FOOTER_API_URL, {
        params: params
    })
}
export const getRedesSociales = async () => {
    const params = {};
    params["populate[0]"] = "redesSociales.logoDark";
    params["populate[1]"] = "redesSociales.logoLight";
    return axios.get(REDES_SOCIALES_API_URL, {
        params: params
    })
}
